import axios from 'axios'
import { BASE_PATH_PORTAL } from '../../constants'

export const getCertificateList = async () => {
  return axios.get(`${BASE_PATH_PORTAL}/data/apliecību_saraksts?offset=0&limit=10`).then((response) => response.data)
}
